import { ScheduleTemplateNameBase } from './base/schedule-template-name-base';

export class ScheduleTemplateName extends ScheduleTemplateNameBase { }